import { fromJS } from 'immutable'
import * as types from './action-types'

const InitialState = fromJS({
  title: 'Info',
  fetching: false,
  description: 'Concrete Rep. is a UK based agency representing artists working in the fashion, editorial and advertising sectors.',
  address: 'Concrete Rep. Studio, 111 - 113 St John Street, London EC1V 4JA, United Kingdom',
  tel: '+44 7854 322 323',
  email: 'info@concreterep.com',
  okText: 'ok',
  thanksText: 'Thanks, check your inbox!',
  signupPlaceholder: 'Infoletter sign up',
  data: null
})

export default (state = InitialState, action) => {
    switch (action.type) {
      case types.REQUEST_INFO:
        return state.set('fetching', true)

      case types.RECEIVE_INFO:
        return state
          .set('fetching', false)
          .set('data', fromJS(action.payload.data.message))

      case types.ERROR_INFO:
        return state 
          .set('fetching', false)
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/info/reducer.js